module.exports = __webpack_public_path__ + "files/6d3371ace5da91a6ef5757080d84b36b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-1.png
// module id = 1454
// module chunks = 60